@if ((collabraService.refreshCollabFlag | async) === false) {
  <iframe
    #collaboraIframe
    [src]="collaboraIframeUrl | safe"
    title="Collabora Online Viewer"
    id="collabora-online-viewer"
    name="collabora-online-viewer"
    loading="lazy"
    allow="clipboard-read *; clipboard-write *; fullscreen *">
  </iframe>
}
<button (click)="onScrollToTop()" mat-fab><mat-icon>arrow_upward</mat-icon></button>
